import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField} from "@fluentui/react";
import NetGrossPicker from "../../Components/NetGrossPicker";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import validateForm from "../../Utilities/validateForm";

function ImportVentureAgreement(props) {
    const [user] = useContext(AuthContext);
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [name, setName] = useState("");
    const [existingAgreements, setExistingAgreements] = useState([]);
    const [selectedAgreement, setSelectedAgreement] = useState(null)
    const [formErrors, setFormErrors] = useState([]);
    const [maxNetValue, setMaxNetValue] = useState(null)

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            agreement_id: selectedAgreement.key ? selectedAgreement.key : null,
            net_value: net,
            vat: vat,
            gross_value: gross,
        };

        if (validateForm(data, ['name', 'agreement_id'], setFormErrors)) {
            fetch(`/api/venture/${props.add}/agreement/sub`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    };

    useEffect(() => {
        const abortController = new AbortController();
        setName("");
        setNet(0);
        setGross(0);
        setExistingAgreements([])
        setSelectedAgreement(null)
        setMaxNetValue(null)
        if (props.add) {
            async function fetchAgreements() {
                await fetch(`/api/venture/${props.add}/agreement/all`, {
                    method: "GET",
                    signal: abortController.signal,
                    headers: {
                        "Authorization": "Bearer " + user.token,
                    },
                }).then(res => res.json())
                    .then(data => {
                        setExistingAgreements(data.map((item) => {
                            return {
                                key: item.agreement_id,
                                text: `${item.venture_name} - ${item.agreement_name}`,
                                maxValue: item.max_net_value,
                                baseValue: item.base_value
                            };
                        }));
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
            fetchAgreements();
        }
        return () => abortController.abort();
    }, [props.add])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign="space-between">
        <PrimaryButton type="submit" form="ImportVentureAgreement">Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    useEffect(() => {
        if(selectedAgreement !== null) {
            setMaxNetValue(selectedAgreement.maxValue)
        }
    },[selectedAgreement])

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Importuj Koszt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id="ImportVentureAgreement">

                <Dropdown
                    label="Wybierz koszt"
                    selectedKey={undefined}
                    onChange={(e, item) => setSelectedAgreement(item)}
                    placeholder="Wybierz z listy"
                    options={existingAgreements}
                    errorMessage={formErrors['agreement_id']}
                    required
                />

                <h4>{selectedAgreement ? 'Baza: ' + selectedAgreement.baseValue  + ' Pozostało: ' + selectedAgreement.maxValue: '' }</h4>
                <TextField required autoFocus label="Nazwa" value={name}
                           onChange={(e) => setName(e.target.value || "")}
                           errorMessage={formErrors['type_id']}/>

                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} maxNet={maxNetValue}/>
            </form>
        </Panel>
    );
}

export default ImportVentureAgreement;